export const routes = [
  {
    path: '/pmd/escopo',
    component: () => import(/* webpackChunkName: "pmd" */ './components/Scope'),
    name: 'pmd.scope',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/pmd/:acompanhamento',
    component: () => import(/* webpackChunkName: "city" */ './components/Get'),
    name: 'city.pmd.get',
    meta: {
      requiresAuth: true
    }
  }
]
